var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"mx-auto",attrs:{"xs12":"","sm8":"","align-center":""}},[_c('settings-form',{staticClass:"mt-3",attrs:{"group":"general"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }